import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformanceAnalysisPeriod,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function useAnalysisPeriod() {
  const analysisPeriod = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisPeriod);

  const setAnalysisPeriod = useCallback((start: Date | null, end: Date | null) => {
    if (start && end) {
      const startStr = start.toISOString().split('T')[0];
      const endStr = end.toISOString().split('T')[0];

      // Só salvar se for um range válido (datas diferentes)
      if (startStr !== endStr) {
        store.dispatch(setFilter({
          analysisPeriod: {
            start: startStr,
            end: endStr,
          },
        }));
      }
      // Se start === end, não salvar (ainda está selecionando)
    } else {
      // Nenhuma data selecionada ou seleção incompleta
      store.dispatch(setFilter({ analysisPeriod: undefined }));
    }
  }, []);

  return {
    analysisPeriod,
    setAnalysisPeriod,
  };
}
